// groupKey identifies a directory group inside the UI (React keys, option values).
export function groupKey(directoryId: string, groupName: string): string {
    return JSON.stringify([directoryId, groupName]);
}

interface GroupFilterDisplayValue {
    condition: string
    filter: string
    directoryId?: string
    directoryName?: string
}

const groupConditionText: { [key: string]: string } = {
    equal: "equals",
    not_equal: "does not equal",
    contains: "contains",
    not_contains: "does not contain",
};

// An exact filter names either one directory group or a group without a
// directory; a pattern filter matches by name across every group.
export function groupFilterDisplayText(filter: GroupFilterDisplayValue, includeFilterType = true): string {
    const filterType = includeFilterType ? "Group " : "";
    const exact = filter.condition === "equal" || filter.condition === "not_equal";
    const directory = exact && filter.directoryId
        ? ` (${filter.directoryName || "Unavailable directory"})`
        : "";

    return `${filterType}${groupConditionText[filter.condition]} "${filter.filter}"${directory}`;
}
